export default __webpack_public_path__ + "static/media/testifySix.8e79478f.png";